import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Text, useBreakpointValue } from "@chakra-ui/react";

interface Props {
  plan: "plus" | "premium";
}

export const PlanLabel: FC<Props> = ({ plan }) => {
  const { t } = useTranslation();
  const type = useBreakpointValue({
    base: "abbreviated" as const,
    lg: "full" as const,
  });

  if (!type) return null;

  const label = t(`planSelect.table.labels.${plan}.${type}`);

  return (
    <Text
      mt={{ base: 0, md: 4 }}
      textAlign="center"
      variant={{ base: "th-t3", md: "th-t1" }}
      whiteSpace="pre-wrap"
    >
      {label}
    </Text>
  );
};
